import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import { login, logout } from '@/api/user';

export default new Vuex.Store({
  state: {
    user: {
      name: localStorage.getItem('name') || '',
      role: localStorage.getItem('role') || '',
      token: localStorage.getItem('token') || '',
      realName: localStorage.getItem('realName') || '',
    },
    isSidebarOpen: true,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.user.token = token;
      localStorage.setItem('token', token);
    },
    SET_USER_INFO(state, info) {
      state.user.name = info.username;
      state.user.role = info.role;
      state.user.realName = info.realName;
      localStorage.setItem('name', info.username);
      localStorage.setItem('role', info.role);
      localStorage.setItem('realName', info.realName);
    },
    LOGOUT(state) {
      state.user.token = '';
      state.user.name = '';
      state.user.role = '';
      state.user.realName = '';
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('role');
      localStorage.removeItem('realName');
    },
    TOGGLE_SIDEBAR(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
  actions: {
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            const { data } = response;
            commit('SET_TOKEN', data.token);
            commit('SET_USER_INFO', {
              username: data.username,
              role: data.role,
              realName: data.realName,
            });
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        logout()
          .then(() => {
            commit('LOGOUT');
            resolve();
          })
          .catch(() => {
            commit('LOGOUT');
            resolve();
          });
      });
    },
    resetToken({ commit }) {
      return new Promise((resolve) => {
        commit('LOGOUT');
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.user.token,
    sidebarOpen: (state) => state.isSidebarOpen,
  },
});
